import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=1c55fa64&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=1c55fa64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c55fa64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c55fa64')) {
      api.createRecord('1c55fa64', component.options)
    } else {
      api.reload('1c55fa64', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=1c55fa64&scoped=true&", function () {
      api.rerender('1c55fa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2R6z7Pyy3zMgI/JS/comp/Voucher.vue"
export default component.exports